import { render, staticRenderFns } from "./WallpaperBuilder.vue?vue&type=template&id=761ccedc&"
import script from "./WallpaperBuilder.vue?vue&type=script&lang=js&"
export * from "./WallpaperBuilder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports